import React from "react";
import styled from "styled-components";

import * as css from "styles/CssVariables.js";

const Icon = styled.div`
  width: ${(props) => (props.iconsize ? props.iconsize : " 14px")};
  min-width: ${(props) => (props.iconsize ? props.iconsize : " 14px")};
  height: ${(props) => (props.iconsize ? props.iconsize : " 14px")};

  transition: 0.2s;

  background-image: url(${(props) => props.icon});
  background-repeat: no-repeat;
  background-size: cover;
`;

const Button = styled.div`
  box-sizing: border-box;
  height: 42px;
  padding: 0 30px;

  background: ${css.BRAND_INDIGO};
  border-radius: 21px;
  border: 0;

  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  white-space: nowrap;

  transition: 0.2s;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  ${(props) =>
    !props.disabled &&
    `&:hover {
    cursor: pointer;

    color: #fff;

    background: ${css.BRAND_GREEN};
  }`}

  &:hover ${Icon} {
    background-image: url(${(props) => props.iconhover});
  }
`;

export default (props) => {
  const {
    onClick,
    parameters,
    id,
    children,
    disabled,
    icon,
    iconHover,
    iconSize,
  } = props;
  return (
    <Button
      onClick={() => {
        if (disabled) return;
        if (onClick) onClick(parameters);
        return;
      }}
      id={id}
      disabled={disabled}
      iconhover={iconHover}
    >
      <Icon icon={icon} iconsize={iconSize} />
      {children}
    </Button>
  );
};
